import {Component, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

declare var yaCounter48820577: any;
@Component({
  selector: 'app-bento',
  templateUrl: './bento.component.html',
  styleUrls: ['./bento.component.sass']
})
export class BentoComponent implements OnInit {
  locale: string = typeof window !== 'undefined' ? document.documentElement.lang: 'ru';

  constructor(public translate: TranslateService) {}

  ngOnInit(): void {

  }

  elements: any[] = [
    {
      event: 'pechenka-ismet',
      link: `https://b2b.telecom.kz/${this.locale}`,
      img: '7.svg',
      text: 'Все сервисы',
      alt: 'services'
    },
    {
      event: 'pechenka-kazakhtelecom',
      link: `https://b2b.telecom.kz/${this.locale}/katalog-uslug`,
      img: '1.svg',
      text: 'Услуги',
      alt: 'telecom'
    },
    {
      event: 'pechenka-it-resheniya',
      link: `https://b2b.telecom.kz/${this.locale}/it-resheniya`,
      img: '2.svg',
      text: 'IT-Решения',
      alt: 'it-resheniya'
    },
    {
      event: 'pechenka-ofd',
      link: 'https://oofd.kz',
      img: '3.svg',
      text: 'ОФД',
      alt: 'OFD'
    },
    {
      event: 'pechenka-markirovka',
      link: 'https://markirovka.ismet.kz',
      img: '4.svg',
      text: 'Маркировка',
      alt: 'markirovka'
    },
    {
      event: 'pechenka-al-farabium',
      link: `https://b2b.telecom.kz/${this.locale}/al-farabium`,
      img: '8.svg',
      text: 'Al-Farabium',
      alt: 'al-farabium'
    },
    {
      event: 'pechenka-ismet-docs',
      link: 'https://docs.telecom.kz',
      img: '5.svg',
      text: 'Docs',
      alt: 'docs'
    },
    {
      event: 'pechenka-ismet-link',
      link: 'https://link.telecom.kz',
      img: '10.svg',
      text: 'Link',
      alt: 'link'
    },
    {
      event: 'pechenka-activation',
      link: `https://activation.telecom.kz/${this.locale}?utm_source=ismet&utm_medium=main-page`,
      img: '11.svg',
      text: 'Activation Hub',
      alt: 'activation'
    },
    {
      event: 'pechenka-ismet-partner',
      link: 'https://partner.ismet.kz',
      img: '6.svg',
      text: 'Partner',
      alt: 'partner'
    }
  ];

  handleYaCounterClick(event: MouseEvent, goal: string, url: string) {
    if (event.button !== 0 && event.button !== 1) return;
    try {
      yaCounter48820577.reachGoal(goal);
    } catch (e) {}
    window.open(url, '_blank');
  }
}
